// extracted by mini-css-extract-plugin
export var alt = "ParagraphSiteOffers-module--alt--b159d";
export var container = "ParagraphSiteOffers-module--container--4dc45";
export var desktopOnly = "ParagraphSiteOffers-module--desktopOnly--c233e";
export var main = "ParagraphSiteOffers-module--main--2281b";
export var mobileOnly = "ParagraphSiteOffers-module--mobileOnly--4251c";
export var textLeft = "ParagraphSiteOffers-module--textLeft--1e529";
export var visuallyHidden = "ParagraphSiteOffers-module--visuallyHidden--d1ad9";